module.exports = __webpack_public_path__ + "img/notwrite.5532e3c0.png";